import { render, staticRenderFns } from "./new_index.vue?vue&type=template&id=5e030046&scoped=true"
import script from "./new_index.vue?vue&type=script&lang=js"
export * from "./new_index.vue?vue&type=script&lang=js"
import style0 from "./new_index.vue?vue&type=style&index=0&id=5e030046&prod&lang=scss&scoped=true"
import style1 from "./new_index.vue?vue&type=style&index=1&id=5e030046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e030046",
  null
  
)

export default component.exports